export class ParametrosSolicitudValida {
  public affiliateDocument: string;
  public affiliateTypeDocument: string;
  public beneficiaryDocument: string;
  public beneficiaryTypeDocument: string;
  public type: number;
}
